import * as TYPE from './mutation-types';

export const togglePopup = ({ commit }, overlayName)  => commit(TYPE.ADD_OVERLAY, overlayName);
export const addPopupData = ({ commit }, params) => commit(TYPE.POPUP_DATA, params);
export const addTitlePopup = ({ commit }, title) => commit(TYPE.TITLE_POPUP, title);
export const closeAllPopups = ({ commit }) => commit(TYPE.CLOSE_ALL_POPUPS);
